module.exports = __webpack_public_path__ + "img/hcpbpjs.fef089da.svg";